import { Alert, Snackbar } from "@mui/material";

export default function AlertSnackbar({ showSnackbar, setShowSnackbar }) {
  return (
    <Snackbar
      open={showSnackbar}
      autoHideDuration={3000}
      onClose={() => setShowSnackbar(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={() => setShowSnackbar(false)}
        severity="success"
        variant="filled"
        sx={{ bgcolor: "primary.main", color: "primary.contrastText" }}
      >
        Changes saved!
      </Alert>
    </Snackbar>
  );
}
